import * as defaultImport from "@splunk/visualizations/Bubble";
export * from "@splunk/visualizations/Bubble";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
